module.exports = __webpack_public_path__ + "img/home-4.9daccb9c.png";